export { sizeOptions } from "../../Drawer/theme/themeOptions";

export enum variantOptions {
  white = "white",
  soft = "soft",
  strong = "strong"
}
